<template>
  <div style="display: inline; width: 100%">
    <label class="input-label" v-if="label">
      {{label}}
      <input class="input-text" :type="type" v-model.trim="localValue" ref="input">
      <div class="input-help" v-html="help" v-if="help"></div>
    </label>
    <div v-else>
      <input class="input-text" :type="type" v-model.trim="localValue" ref="input">
      <div class="input-help" v-html="help" v-if="help"></div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'InputTextField',
  props: {
    value: {
      type: [String, Number, Array]
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    null2undefined: { type: Boolean, default: false },
    text2array: { type: Boolean, default: false }
  },
  methods: {
    focus () {
      this.$refs.input.focus();
    }
  },
  computed: {
    localValue: {
      get () {
        if (this.text2array && Array.isArray(this.value)) {
          return this.value
            .map(word => word === undefined ? 'undefined' : word)
            .map(word => word === null ? 'undefined' : word)
            .join(',');
        }
        if (this.type === 'number' && this.value !== null && this.value !== undefined) {
          return this.value;
        }
        return this.value || null;
      },
      set (v) {
        let finalValue = v;

        if (this.text2array && typeof v === 'string') {
          finalValue = v.split(',')
            .map(word => word.trim())
            .map(word => word === 'null' ? undefined : word)
            .map(word => word === 'undefined' ? undefined : word);
        } else if (this.type === 'number' && v !== '' && v !== null) {
          finalValue = Number(v);
        } else if (this.type === 'number' && v === '') {
          finalValue = null;
        }

        if (this.null2undefined && (finalValue === null || finalValue === '')) {
          finalValue = undefined;
        }

        this.$emit('input', finalValue);
      }
    }
  }
};
</script>
